import { Box, Button, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { Dialog } from 'components/Dialogs';
import { actionsContainerSx, confirmationBodySx } from './AcceptAICapTableModal.styles';

export interface AICapTableBulkActionModalProps {
  open: boolean;
  title: string;
  bodyText: string;
  helperText: string;
  confirmText: string;
  submittingText: string;
  confirmButtonSx?: SxProps<Theme>;
  cancelTestId: string;
  confirmTestId: string;
  contentId: string;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  isSubmitting?: boolean;
}

const AICapTableBulkActionModal = ({
  open,
  title,
  bodyText,
  helperText,
  confirmText,
  submittingText,
  confirmButtonSx,
  cancelTestId,
  confirmTestId,
  contentId,
  onClose,
  onConfirm,
  isSubmitting = false,
}: AICapTableBulkActionModalProps) => (
  <Dialog open={open} onClose={onClose} title={title} maxWidth="sm" fullWidth>
    <Box id={contentId} sx={confirmationBodySx}>
      <Typography>{bodyText}</Typography>
      <Typography variant="body2" color="text.secondary">
        {helperText}
      </Typography>
    </Box>
    <Box sx={actionsContainerSx}>
      <Button
        variant="outlined"
        color="primary"
        onClick={onClose}
        disabled={isSubmitting}
        data-testid={cancelTestId}>
        Cancel
      </Button>
      <Button
        onClick={() => onConfirm()}
        disabled={isSubmitting}
        sx={confirmButtonSx}
        data-testid={confirmTestId}>
        {isSubmitting ? submittingText : confirmText}
      </Button>
    </Box>
  </Dialog>
);

export default AICapTableBulkActionModal;
